import i18n from "../../../../i18n";
    const IncidentID = i18n.t('manageAutomation.IncidentID');
    const AssignedTo = i18n.t('manageAutomation.AssignedTo');
    const IncidentStatus = i18n.t('manageAutomation.IncidentStatus');
    const Priority = i18n.t('manageAutomation.Priority');
    const ProcessName = i18n.t('manageAutomation.ProcessName');
    const JobID = i18n.t('manageAutomation.JobID');
    const Duration = i18n.t('manageAutomation.Duration');
    const Session = i18n.t('manageAutomation.Session');
    const Status = i18n.t('manageAutomation.Status');
    const UpdatedOn = i18n.t('manageAutomation.UpdatedOn');
    const Client = i18n.t('manageAutomation.Client');
    const Technology = i18n.t('manageAutomation.Technology');
    const Category = i18n.t('manageAutomation.Category');
    const SubCategory = i18n.t('manageAutomation.SubCategory');
    const BuisnessOwner = i18n.t('manageAutomation.BuisnessOwner');
    const SLADueIn = i18n.t('manageAutomation.SLADueIn');
    const Franchise = i18n.t('manageAutomation.Franchise');
    const IncidentURL = i18n.t('manageAutomation.IncidentURL');
    const SysId= i18n.t('manageAutomation.SysId');
    const skillName = i18n.t('manageAutomation.skillName');
    const StartedOn = i18n.t('manageAutomation.StartedOn');
    const automataResource = i18n.t('manageAutomation.AutomataResource');
    const userName = i18n.t('manageAutomation.UserName');


const RUNNING_ALERT_HEADERS = [
    {
      key: 'incidentId',
      header: IncidentID,
      hidden: false,
      optional: false
    },
    {
      key: 'sessionNo',
      header: Session,
      hidden: false,
      optional: false
    },
    {
      key: 'assigned_to',
      header: AssignedTo,
      hidden: false,
      optional: false
    },
    {
      key: 'incident_status',
      header: IncidentStatus,
      hidden: false,
      optional: false
    },
    {
      key: 'priority',
      header: Priority,
      hidden: false,
      optional: false
    },
    {
      key: 'SLA_due_in',
      header: SLADueIn,
      hidden: true,
      optional: true
    },
    {
      key: 'automataName',
      header: ProcessName,
      hidden: false,
      optional: false
    },
    {
      key: 'category',
      header: Category,
      hidden: true,
      optional: true
    },
    {
      key: 'subCategory',
      header: SubCategory,
      hidden: true,
      optional: true
    },
    {
      key: 'buisnessOwner',
      header: BuisnessOwner,
      hidden: true,
      optional: true
    },
    {
      key: 'job_id',
      header: JobID,
      hidden: true,
      optional: true
    },
    {
      key: 'duration',
      header: Duration,
      hidden: true,
      optional: false
    },
    {
      key: 'client',
      header: Client,
      hidden: true,
      optional: true
    },
    {
      key: 'franchise',
      header: Franchise,
      hidden: true,
      optional: false
    },
    // {
    //   key: 'sessionNo',
    //   header: Session,
    //   hidden: true,
    //   optional: true
    // },
    {
      key: 'status',
      header: Status,
      hidden: true,
      optional: true
    },
    {
      key: 'startedOn',
      header: StartedOn,
      hidden: false,
      optional: false
    },
    {
      key: 'updatedOn',
      header: UpdatedOn,
      hidden: false,
      optional: false
    },
    
    {
      key: 'technology',
      header: Technology,
      hidden: true,
      optional: true
    },
    {
        key: 'incidentURL',
        header: IncidentURL,
        hidden: true,
        optional: false
    },
    {
      key: 'sysId',
      header: SysId,
      hidden: true,
      optional: false
    },
    {
        key: 'skillName',
        header: skillName,
        hidden: true,
        optional: true
    },
    {
      key: 'automataresource',
      header: automataResource,
      hidden: true,
      optional: true
    },
    {
      key: 'username',
      header: userName,
      hidden: true,
      optional: true
    },
  ];
  export default RUNNING_ALERT_HEADERS;